// AbrirChamado.js (Revisado: Tela de Sucesso + UX)

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from './firebase';
import { collection, addDoc, doc, runTransaction, serverTimestamp } from './firestore-compat';
import ModalCriacaoUsuario from './ModalCriacaoUsuario';

function AbrirChamado() {
    const [solicitanteNome, setSolicitanteNome] = useState('');
    const [solicitanteSetor, setSolicitanteSetor] = useState('');
    const [solicitanteEmail, setSolicitanteEmail] = useState('');
    const [solicitanteWhatsApp, setSolicitanteWhatsApp] = useState('');

    // Default values
    const [category, setCategory] = useState('Suporte');
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [priority, setPriority] = useState('Média');

    // Modais e Estados UI
    const [isUserModalOpen, setIsUserModalOpen] = useState(false);
    const [dadosNovoUsuario, setDadosNovoUsuario] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [message, setMessage] = useState('');

    // Estado da Tela de Sucesso
    const [ticketCreated, setTicketCreated] = useState(null); // { idPublico: 1050 }

    useEffect(() => {
        if (category === 'Criação de Usuário') {
            setIsUserModalOpen(true);
        }
    }, [category]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setIsSubmitting(true);

        // Validação Básica
        if (!solicitanteNome || !solicitanteEmail || !title || !description) {
            setMessage('Por favor, preencha todos os campos obrigatórios.');
            setIsSubmitting(false);
            return;
        }

        // Validação de Modal Específico
        if (category === 'Criação de Usuário' && !dadosNovoUsuario) {
            setMessage('Por favor, preencha os dados do novo usuário clicando no botão.');
            setIsUserModalOpen(true);
            setIsSubmitting(false);
            return;
        }

        try {
            // 1. Geração Segura do ID Público
            const contadorRef = doc(db, 'contadores', 'chamados');

            const novoNumeroChamado = await runTransaction(db, async (transaction) => {
                const contadorDoc = await transaction.get(contadorRef);
                const numeroAtual = contadorDoc.exists() ? contadorDoc.data().numeroAtual : 1000;
                const novoNumero = numeroAtual + 1;
                transaction.set(contadorRef, { numeroAtual: novoNumero });
                return novoNumero;
            });

            // 2. Montar Objeto
            const newChamado = {
                idPublico: novoNumeroChamado,
                status: 'Aberto',
                createdAt: serverTimestamp(),

                solicitanteNome,
                solicitanteSetor,
                solicitanteEmail: solicitanteEmail.toLowerCase().trim(),
                solicitanteWhatsApp,

                category,
                title,
                description,
                priority,
                dadosNovoUsuario: dadosNovoUsuario,
                assignedToName: null,
                closedAt: null,
            };

            const docRef = await addDoc(collection(db, 'chamados'), newChamado);

            // 3. Log inicial
            await addDoc(collection(db, "chamados", docRef.id, "mensagens"), {
                texto: `Chamado ${novoNumeroChamado} aberto. Aguardando triagem.`,
                de: "Sistema",
                tipo: "sistema",
                timestamp: serverTimestamp(),
            });

            // SUCESSO! Trocamos a tela.
            setTicketCreated({ idPublico: novoNumeroChamado, email: solicitanteEmail });

            // Salva e-mail para facilitar futuro acompanhamento
            localStorage.setItem('chamados_user_email', solicitanteEmail.toLowerCase().trim());

        } catch (error) {
            console.error("Erro ao abrir chamado: ", error);
            setMessage(`❌ Erro técnico: ${error.message}. Tente novamente.`);
            setIsSubmitting(false); // Só destrava se der erro
        }
    };

    const handleSaveUserModal = (dados) => {
        setDadosNovoUsuario(dados);
        setIsUserModalOpen(false);
    };

    const resetForm = () => {
        setTicketCreated(null);
        setSolicitanteNome('');
        setSolicitanteSetor('');
        // Mantemos o email para facilitar
        // setSolicitanteEmail('');
        setSolicitanteWhatsApp('');
        setTitle('');
        setDescription('');
        setPriority('Média');
        setCategory('Suporte');
        setDadosNovoUsuario(null);
        setIsSubmitting(false);
    };

    // --- TELA DE SUCESSO ---
    if (ticketCreated) {
        return (
            <div className="chamados-container success-screen">
                <main className="settings-main centered-box">
                    <div className="success-icon">✅</div>
                    <h1>Chamado #{ticketCreated.idPublico} Criado!</h1>
                    <p>Sua solicitação foi registrada com sucesso e já está na nossa fila.</p>

                    <div className="info-box">
                        <p><strong>Guarde este número:</strong> #{ticketCreated.idPublico}</p>
                        <p>Enviamos uma confirmação para: <strong>{ticketCreated.email}</strong></p>
                    </div>

                    <div className="action-buttons-column">
                        <Link to="/meus-chamados" className="btn-save btn-full">
                            Acompanhar meu Pedido
                        </Link>

                        <button onClick={resetForm} className="btn-portal btn-outline">
                            Abrir Outro Chamado
                        </button>

                        <Link to="/login" className="link-simple">
                            Voltar ao Início
                        </Link>
                    </div>
                </main>
            </div>
        );
    }

    // --- FORMULÁRIO PADRÃO ---
    return (
        <div className="chamados-container">
            <div className="page-header" style={{ marginBottom: '20px' }}>
                <h2 style={{ color: '#555', margin: 0 }}>Abrir Novo Chamado</h2>
            </div>

            <main className="settings-main">
                <form onSubmit={handleSubmit} className="add-user-container">

                    <div className="form-group">
                        <label htmlFor="solicitanteNome">Seu Nome Completo</label>
                        <input id="solicitanteNome" type="text" value={solicitanteNome} onChange={(e) => setSolicitanteNome(e.target.value)} required />
                    </div>

                    <div className="form-group-row">
                        <div className="form-group">
                            <label htmlFor="solicitanteSetor">Seu Setor</label>
                            <input id="solicitanteSetor" type="text" value={solicitanteSetor} onChange={(e) => setSolicitanteSetor(e.target.value)} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="solicitanteWhatsApp">Seu WhatsApp</label>
                            <input id="solicitanteWhatsApp" type="tel" value={solicitanteWhatsApp} onChange={(e) => setSolicitanteWhatsApp(e.target.value)} placeholder="(XX) XXXXX-XXXX" />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="solicitanteEmail">Seu E-mail</label>
                        <input id="solicitanteEmail" type="email" value={solicitanteEmail} onChange={(e) => setSolicitanteEmail(e.target.value)} required />
                    </div>

                    <hr className="form-divider" />

                    <div className="form-group-row">
                        <div className="form-group">
                            <label htmlFor="category">Categoria do Chamado:</label>
                            <select id="category" value={category} onChange={(e) => setCategory(e.target.value)} required>
                                <option value="Suporte">Suporte (TI)</option>
                                <option value="Acesso ao Sistema">Acesso ao Sistema</option>
                                <option value="Criação de Usuário">Criação de Usuário</option>
                                <option value="Solicitação">Solicitação (Ex: Relatório)</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="priority">Grau de Urgência:</label>
                            <select id="priority" value={priority} onChange={(e) => setPriority(e.target.value)} required>
                                <option value="Baixa">Baixa</option>
                                <option value="Média">Média</option>
                                <option value="Alta">Alta</option>
                                <option value="Crítico">Crítico</option>
                            </select>
                        </div>
                    </div>

                    {category === 'Criação de Usuário' && (
                        <div className="form-group">
                            <button
                                type="button"
                                className="btn-secondary"
                                onClick={() => setIsUserModalOpen(true)}
                            >
                                {dadosNovoUsuario ? '✓ Dados do Novo Usuário Preenchidos' : 'Preencher Dados do Novo Usuário'}
                            </button>
                        </div>
                    )}

                    <div className="form-group">
                        <label htmlFor="title">Título / Assunto</label>
                        <input id="title" type="text" value={title} onChange={(e) => setTitle(e.target.value)} maxLength="80" required />
                    </div>

                    <div className="form-group">
                        <label htmlFor="description">Descrição Detalhada</label>
                        <textarea id="description" value={description} onChange={(e) => setDescription(e.target.value)} rows="6" required></textarea>
                    </div>

                    {message && (
                        <div className={`form-message error`}>
                            {message}
                        </div>
                    )}

                    <div className="modal-actions">
                        <button type="submit" className="btn-save btn-full" disabled={isSubmitting}>
                            {isSubmitting ? 'Enviando...' : 'Confirmar Abertura'}
                        </button>
                    </div>
                </form>
            </main>

            <ModalCriacaoUsuario
                isOpen={isUserModalOpen}
                onClose={() => setIsUserModalOpen(false)}
                onSave={handleSaveUserModal}
            />
        </div>
    );
}

export default AbrirChamado;